import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import config from '../config';

const namespaces = ['common', 'home', 'about', 'experience', 'projects', 'technology', 'interest', 'hobby', 'search'];

function getInitialLanguage(): string {
  const pathname = window.location.pathname;
  if (pathname.startsWith('/ru')) return 'ru';
  if (pathname.startsWith('/it')) return 'it';
  if (pathname.startsWith('/fr')) return 'fr';
  return config.defaultLang;
}

type RequestCallback = (error: unknown, response: { status: number; data: string }) => void;

function customRequest(_options: unknown, url: string, _payload: unknown, callback: RequestCallback): void {
  fetch(url, { cache: 'no-store' })
    .then(res => {
        console.log("url :" + config.i18nFallbackApiUrl)
      if (res.ok && res.headers.get('content-type')?.includes('application/json')) {
        return res.text().then(data => callback(null, { status: 200, data }));
      }

      if (!config.i18nFallbackApiUrl) {
        callback(null, { status: res.status, data: '' });
        return;
      }

      // Extract lng and ns from local path to build API URL
      const match = url.match(/\/locales\/([^/]+)\/([^/]+)\.json$/);
      if (!match) {
        callback(null, { status: 404, data: '' });
        return;
      }
      const [, lng, ns] = match;
      const apiUrl = `${config.i18nFallbackApiUrl}/${lng}/${ns}.json`;
      const defaultLngUrl = url.replace(/\/locales\/[^/]+\//, `/locales/${config.defaultLang}/`);

      fetch(defaultLngUrl)
        .then(defaultRes => defaultRes.ok ? defaultRes.json() : null)
        .catch(() => null)
        .then(defaultTranslations => fetch(apiUrl, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify({ lng, ns, defaultTranslations }),
        }))
        .then(apiRes => {
          if (apiRes.ok) {
            return apiRes.text().then(data => callback(null, { status: 200, data }));
          }
          callback(null, { status: apiRes.status, data: '' });
        })
        .catch(err => callback(err, { status: 500, data: '' }));
    })
    .catch(err => callback(err, { status: 500, data: '' }));
}

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: getInitialLanguage(),
    fallbackLng: config.defaultLang,
    ns: namespaces,
    defaultNS: 'common',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      request: customRequest,
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
